// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries
import { withTranslation } from 'shared/utils/withTranslation'

export class EmbeddableCartErrors extends Component {
  static displayName = 'EmbeddableCartErrors'

  static propTypes = {
    hasDates: PropTypes.bool,
    cannotCheckout: PropTypes.bool,
    t: PropTypes.func
  }

  render () {
    const { hasDates, cannotCheckout, t } = this.props

    let errorText

    if (hasDates && cannotCheckout) {
      errorText = t('user.store.not_all_products_available')
    }

    if (!hasDates) {
      errorText = t('user.store.select_a_period', 'Select a rental period')
    }

    if (!errorText) return null

    return (
      <div className="bq-cart-error">
        <i className="fas fa-exclamation-triangle" />
        <span>{errorText}</span>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const cart = state.orm.carts.getById(state.client.cartId)
  const hasDates = !!(cart && cart.starts_at && cart.stops_at)
  const useAvailability = state.settings.get('store.use_availability')

  let cannotCheckout

  // Check if we need to calculate if use can checkout
  if (useAvailability) {
    cannotCheckout =
      state.orm.lines
        .getAll({
          id: cart != null ? cart.lines : undefined,
          can_checkout: false
        })
        .size() > 0
  } else {
    cannotCheckout = false
  }

  return {
    hasDates,
    cannotCheckout
  }
}

const reduxComponent = reduxConnect(mapStateToProps, null)(EmbeddableCartErrors)

export default withTranslation('user')(reduxComponent)
